export const ServerSentEventTypes = {
	INIT_SERVER_SENT_EVENT: 'INIT_SERVER_SENT_EVENT',
	OPEN_SERVER_SENT_EVENT: 'OPEN_SERVER_SENT_EVENT',
	MESSAGE_SERVER_SENT_EVENT: 'MESSAGE_SERVER_SENT_EVENT',
	CLOSE_SERVER_SENT_EVENT: 'CLOSE_SERVER_SENT_EVENT'
}